<template>
  <div class="address">
    <div class="edit" v-if="state.isEdited">
      <div class="detail-wrapper clearfix">
        <div class="address-title">填写收货地址</div>
        <!-- <p class="address-desc">请您确认收货地址用于邮寄礼品</p> -->
        <div class="address">
          <div class="address-bar">
            <div class="row">
              <span class="address--lable">收货人</span>
              <input
                class="address--info__val"
                @input.once="inputLog(12)"
                @blur="handleInputBlur"
                placeholder="收货人"
                maxlength="10"
                v-model="userInfo.name"
              />
            </div>
            <div class="row">
              <span class="address--lable">联系电话</span>
              <input
                class="address--info__val"
                @input.once="inputLog(13)"
                @focus="onPhoneFocus"
                @blur="handleInputBlur"
                placeholder="联系电话"
                maxlength="11"
                v-model="userInfo.phone"
                type="tel"
              />
            </div>
            <div class="row" @click="$refs.picker.visible = true">
              <span class="address--lable">所在地区</span>
              <span class="address--info__val" :class="[userInfo.province_id === '' && 'gray']">
                {{
                  userInfo.province_id === ''
                    ? '所在地区'
                    : `${location.provinceName} ${location.cityName} ${location.countyName}`
                }}
              </span>
              <div class="right-icon"><van-icon name="arrow" /></div>
            </div>
            <div class="row">
              <span class="address--lable">详细地址</span>
              <input
                class="address--info__val"
                @input.once="inputLog(14)"
                @blur="handleInputBlur"
                placeholder="详细地址"
                maxlength="33"
                v-model="userInfo.detail"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="confim-box">
        <div class="tips">
          <div>
            <!-- 奖品将在活动结束后统一寄送~ -->
          </div>
          <div>
            物流查看方式：学而思网校App--我的--查快递
          </div>
        </div>
        <div class="confim-btn" @click="handleBtnSubmit">保存</div>
      </div>
    </div>
    <div class="check" v-else>
      <div class="clearfix">
        <img class="check-correct" src="./assets/images/correct.png" v-if="addressId === '0'" />
        <div v-else class="address-title">收货地址</div>
        <p class="check-desc" v-if="addressId === '0'">填写成功</p>
        <p class="check-desc2" v-else>该收货地址仅用于邮寄奖品</p>
        <div class="check-address" :class="addressId === '0' ? 'checks-add' : 'checks-check'">
          <div class="check-address-bar">
            <div class="check-row">
              <span class="address--lable">收货人</span>
              <div class="address--cont">{{ addrInfo.recipient_name }}</div>
            </div>
            <div class="check-row">
              <span class="address--lable">联系电话</span>
              <div class="address--cont">{{ addrInfo.recipient_phone }}</div>
            </div>
            <div class="check-row">
              <span class="address--lable">所在地区</span>
              <div class="address--cont">
                {{ addrInfo.province_name }}{{ addrInfo.city_name }}{{ addrInfo.county_name }}
              </div>
            </div>
            <div class="check-row">
              <span class="address--lable">详细地址</span>
              <div class="address--cont">{{ addrInfo.recipient_adds }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tips" v-if="addressId === '0'">
        注意：收货地址只支持提交一次，请确认或编辑后提交，提交后不可修改。
      </div>
    </div>
    <locationPicker ref="picker" @setLocation="handleSetLocation" />

    <!-- 登录注册 -->
    <van-popup v-model="state.loginShow" class="x-van-popup">
      <xes-tal-login
        :loginData="loginData"
        @loginSuccess="loginSuccess"
        @regSuccess="regSuccess"
        @sendVCode="sendVCode"
        @close="state.loginShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import locationPicker from './components/locationPicker' // 省市联动组件
import Validator from './utils/Validator' // 参数校验
import { XesTalLogin } from '@xes/terra' // 新登陆态
import area from './assets/area.json'

export default {
  name: 'addressPage',
  components: {
    locationPicker,
    'xes-tal-login': XesTalLogin
  },
  props: {
    addressId: {
      type: String,
      default: '0'
    },
    isLogin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      userId: '0', // 测试用id
      state: {
        loginShow: false, // 登录窗
        loginstate: false, // 是否需要登录
        isEdited: true, // 用户是否已经填写过地址（是否处于可编辑状态）
        needAddress: true // 地址填写
      },
      // 地址填写完成展示数据
      addrInfo: {
        recipient_name: '',
        recipient_phone: '',
        province_name: '',
        city_name: '',
        county_name: '',
        recipient_adds: ''
      },
      // 地址默认获取与填写信息
      userInfo: {
        id: '', // 收货地址id
        name: '',
        phone: '',
        province_id: '',
        city_id: '',
        county_id: '',
        detail: ''
      },
      // 用户收货地址信息
      location: {
        provinceName: '',
        cityName: '',
        countyName: ''
      },
      common_params: '', // 日志公共字段
      regData: {
        sGroupId: '888758',
        source_id: '',
        adsite_id: '',
        monitor_type: ''
      }, // 注册所需参数
      loginData: {
        sGroupId: '888758',
        source_id: ''
      }, // 登录所需参数
      logisticsInfo: {
        addrId: '', // 地址id
        name: '', // 收货人姓名
        phone: '', // 收货人手机号
        proId: '', // 所有所在省份
        citId: '', // 用户所在市、区
        couId: '', // 收货区县地址
        detail: '', // 地址详情
        note: '' // 备注信息
      }, // 物流地址
      rewardId: 0 // 奖励id
    }
  },
  created() {
    this.$toast.loading({
      message: '加载中',
      mask: true,
      duration: 0
    })
    if (this.isLogin) {
      this.state.loginstate = true
      this.addrInfos()
      return
    }
    this.$api.checkLogin().then(res => {
      if (!res.stat == 1) {
        this.$toast.clear()
        // this.$toast('当前没有登录！请先去登录')
        this.state.loginstate = false
        // setTimeout(() => {
        this.state.loginShow = true
        // }, 2000)
      } else {
        this.state.loginstate = true
        this.addrInfos()
      }
    })
  },
  mounted() {
    this.common_params = 'pagename=地址填写页&pagelevel=3'
    this.rewardId = this.$route.query.rewardId || 0
  },
  watch: {
    addressId(val, oldval) {
      if (val !== oldval) {
        this.addrInfos()
      }
    }
  },
  methods: {
    //  获取地址（中台）
    addrInfos() {
      if (this.addressId === '0') {
        this.addressA()
      } else {
        this.addressB()
      }
    },
    // 查询地址 中台
    addressA() {
      this.$api.addrInfos().then(res => {
        this.$toast.clear()
        if (res.stat !== 1) {
          this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=9` })
          this.$toast('地址获取失败!请退出重试')
          return false
        }
        if (res.data.total !== 0) {
          if (this.addressId !== '0') {
            const _addressId = res.data.list
            _addressId.map(item => {
              if (item.id === this.addressId) {
                this.state.isEdited = false
                this.addrInfo = {
                  recipient_name: item.name,
                  recipient_phone: item.phone,
                  province_name: item.province_name,
                  city_name: item.city_name,
                  county_name: item.county_name,
                  recipient_adds: item.detail
                }
              }
            })
            if (this.addrInfo.recipient_name === '') {
              this.state.isEdited = false
              this.addrInfo = {
                recipient_name: _addressId[0].name,
                recipient_phone: _addressId[0].phone,
                province_name: _addressId[0].province_name,
                city_name: _addressId[0].city_name,
                county_name: _addressId[0].county_name,
                recipient_adds: _addressId[0].detail
              }
            }
            this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=11` })
          }
          this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=10` })
          let defAddr = res.data.list[0] || {}
          for (const addr of res.data.list) {
            if (addr.is_default === '1') {
              defAddr = addr
            }
          }
          // if (Boolean(defAddr) === false) {
          //   defAddr = res.data.list[0]
          // }
          // defAddr.phone = ''
          this.userInfo = defAddr
          this.location.provinceName = defAddr.province_name
          this.location.cityName = defAddr.city_name
          this.location.countyName = defAddr.county_name
        }
      })
    },
    // 查询地址 物流
    addressB() {
      this.$api.getAddressInfo(this.addressId).then(res => {
        this.$toast.clear()
        if (res.code === 0) {
          if (
            res.data.detail[this.addressId] !== undefined &&
            res.data.detail[this.addressId] !== 'undefined'
          ) {
            const _address = res.data.detail[this.addressId] // {provinceId: '1',cityId: '1',countyId: '1',detail: '测试地址',name: 'gaoge',phone: '135****4567'}
            const _area = Object.keys(area) // ["省份", "北京市", "天津市", "河北省", "山西省", "内蒙古自治区", "辽宁省",...]
            const _provinceName = _area[_address.provinceId] // 省名称
            let _cityName, _county // 市名称 区
            for (const [prop, value] of Object.entries(area[_provinceName].items)) {
              if (value.val === _address.cityId) {
                _cityName = prop // 市辖区
                _county = value.items // {东城区: "1", 西城区: "2", 朝阳区: "5", 丰台区: "6", 石景山区: "7",…}
              }
            }
            const _countyName = this.findKey(_county, _address.countyId) // 东城区

            this.addrInfo = {
              recipient_name: _address.name,
              recipient_phone: _address.phone,
              province_name: _provinceName, // 省
              city_name: _cityName, // 市
              county_name: _countyName, // 区
              recipient_adds: _address.detail
            }
            this.state.isEdited = false
          } else {
            this.$toast('地址获取失败!请退出重试')
          }
        } else {
          this.$toast('地址获取失败!请退出重试')
        }
      })
    },
    findKey(obj, value, compare = (a, b) => a === b) {
      return Object.keys(obj).find(k => compare(obj[k], value))
    },
    // 地址提交
    async handleBtnSubmit() {
      if (!this.state.loginstate) {
        this.$toast('当前没有登录！请先去登录')
        setTimeout(() => {
          this.state.loginShow = true
        }, 1000)
        return false
      }
      if (this.state.needAddress === true) {
        // 以下是地址填写逻辑
        const { userInfo } = this
        // 参数校验
        const validator = new Validator()
        const validateRes = validator
          .add(userInfo.name, 'isNotEmpty', '请填写收货人姓名')
          .add(userInfo.name, 'isValidName', '收货人姓名格式不规范，请修改后重新提交~')
          .add(userInfo.phone.replace(/\s/g, ''), 'isNotEmpty', '请输入收货人手机号')
          .add(userInfo.phone.replace(/\s/g, ''), 'isMobile', '请输入正确的手机号')
          .add(userInfo.province_id, 'isNotEmpty', '请选择所在地区')
          .add(userInfo.detail, 'isNotEmpty', '请输入详细地址')
          .add(userInfo.detail, 'isValidDetail', '详细地址内包含非法字符，请修改后重新提交~')
          .run()
        if (validateRes !== undefined) {
          // 参数未能通过校验
          this.$toast(validateRes)
          return false
        }
        // 参数已通过校验
        await this.$dialog
          .confirm({
            title: '确认使用该地址？',
            // eslint-disable-next-line
            message: `地址一旦保存并使用后无法修改`
          })
          // eslint-disable-next-line space-before-function-paren
          .then(async () => {
            this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=6` })
            this.$toast.loading({
              message: '订单地址保存中',
              mask: true,
              duration: 0
            })
            this.addrInfo = {
              recipient_name: userInfo.name,
              recipient_phone: userInfo.phone,
              province_name: this.location.provinceName,
              city_name: this.location.cityName,
              county_name: this.location.countyName,
              recipient_adds: userInfo.detail
            }
            const payload = {
              addrId: userInfo.id,
              name: userInfo.name, // 收货人姓名
              phone: userInfo.phone, // 收货人手机号
              proId: userInfo.province_id, // 省id
              citId: userInfo.city_id, // 市id
              couId: userInfo.county_id, // 区id
              detail: userInfo.detail, // 详细地址
              isDef: userInfo.is_default || 1
            }
            if (userInfo.phone.includes('****')) {
              delete payload.phone
            }

            if (!userInfo.id) {
              delete payload.addrId
            }

            this.logisticsInfo = payload

            this.addAddress()
          })
          .catch(() => {})
      }
    },
    // 将数据发送给后台
    addAddress() {
      this.$api
        .addrMod(this.logisticsInfo)
        .then(res => {
          this.$toast.clear()
          if (res.stat === 1) {
            this.$emit('submitCallback', {
              stat: 1,
              addrId: res.data.id
            })
          } else {
            this.$emit('submitCallback', {
              stat: 0,
              msg: res.msg || '未知错误'
            })
          }
          console.log('submitAddress', res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置地址事件
    handleSetLocation(location) {
      this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=5` })
      const { provinceName, cityName, countyName, province_id, city_id, county_id } = location
      this.location = {
        provinceName,
        cityName,
        countyName
      }
      this.userInfo.province_id = province_id
      this.userInfo.city_id = city_id
      this.userInfo.county_id = county_id
    },
    // input框输入事件日志打点
    inputLog(clickid) {
      this.$xesLogger.clickMsg({ params: `${this.common_params}&clickid=4` })
    },
    // 防止iOS 全面屏点击漂移
    handleInputBlur() {
      setTimeout(() => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        document.getElementsByTagName('html')[0].scrollTop = scrollTop
        // 测试过程中发现只需要下面这一条即可
        document.getElementsByTagName('body')[0].scrollTop = scrollTop
      }, 0)
    },
    // 当用户想修改默认地址的手机号时 自动清空手机号
    onPhoneFocus() {
      if (this.userInfo.phone.includes('****')) {
        this.userInfo.phone = ''
      }
    },
    //  点击获取验证码按钮
    sendVCode(params) {
      this.$xesLogger.clickMsg({
        params: `${this.common_params}&clickid=1`
      })
    },
    //  老用户登录成功
    loginSuccess(params) {
      this.state.loginShow = false
      this.state.loginstate = true
      this.addrInfos()
      this.$xesLogger.clickMsg({
        params: `${this.common_params}&clickid=2&is_new=0`
      })
    },
    //  新用户注册成功
    regSuccess(params) {
      this.state.loginShow = false
      this.state.loginstate = true
      this.addrInfos()
      this.$xesLogger.clickMsg({
        params: `${this.common_params}&clickid=3&is_new=1`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.address {
  width: 100%;
  background: white;
  // min-height: 100vh;

  &-title {
    padding-top: 40px;
    font-size: 19px;
    font-weight: 500;
    font-family: PingFang SC;
    text-align: center;
    color: rgba(33, 40, 49, 1);
  }

  &-desc {
    padding-top: 10px;
    font-size: 15px;
    font-weight: 400;
    font-family: PingFang SC;
    text-align: center;
    color: rgba(133, 140, 150, 1);
  }

  .address {
    width: 346px;
    padding: 0 15px;
    margin: 30px auto 130px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.06);

    &-bar {
      display: flex;
      flex-direction: column;

      .row {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 56px;
        padding-top: 3px;
        border-bottom: 1px solid #f1f1f1;

        .address--lable {
          font-size: 15px;
          font-weight: 400;
          font-family: PingFang SC;
          color: rgba(51, 51, 51, 1);
        }

        .address--info__val {
          width: 235px;
          font-size: 14px;
          font-weight: 400;
          font-family: PingFangSC-Regular;
          // line-height: 10px;
          color: rgba(51, 51, 51, 1);
          border: none;
          border-radius: 0;
        }

        .warning {
          position: absolute;
          bottom: 10px;
          left: 15px;
          font-size: 12px;
          color: #d94948;
        }

        .right-icon {
          position: absolute;
          top: 18px;
          right: 8px;
          width: 9px;
          height: 10px;
          font-size: 15px;
          font-weight: 400;
          font-family: PingFang SC;
          color: rgba(33, 40, 49, 1);
          // background-image: url('../../images/address-down.png');
          // background-size: contain;
        }

        .gray {
          color: #a9a9a9;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

  .confim-box {
    position: relative;
    margin: -120px 0 0;

    .tips {
      width: 300px;
      padding-bottom: 15px;
      margin: 0 auto;
      font-size: 13px;
      font-weight: 400;
      font-family: PingFang SC;
      text-align: center;
      color: rgba(133, 140, 150, 1);
    }
  }

  .confim-btn {
    width: 348px;
    height: 53px;
    margin: 0 auto;
    font-size: 18px;
    font-weight: 500;
    font-family: PingFang SC;
    line-height: 53px;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    background: rgba(234, 89, 72, 1);
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 3px;
  }

  .clearfix {
    display: inline-block;

    &::after {
      display: block;
      content: '';
      height: 0;
      line-height: 0;
      clear: both;
      visibility: hidden;
    }
  }

  .detail-wrapper {
    width: 100%;
    min-height: 100vh;
  }

  .check {
    &-correct {
      display: block;
      width: 31px;
      height: 31px;
      margin: 25px auto 0;
    }

    &-desc {
      padding-top: 16px;
      font-size: 19px;
      font-weight: 500;
      font-family: PingFang SC;
      text-align: center;
      color: rgba(33, 40, 49, 1);
    }

    &-desc2 {
      padding-top: 16px;
      font-size: 14px;
      font-weight: 500;
      font-family: PingFang SC;
      text-align: center;
      color: rgba(33, 40, 49, 1);
    }

    .checks-add {
      margin: 50px auto 70px;
    }

    .checks-check {
      margin: 15px auto 40px;
    }

    &-address {
      width: 346px;
      padding: 0 15px;

      &-bar {
        display: flex;
        flex-direction: column;

        .check-row {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          height: 35px;
          padding-top: 3px;
          font-size: 15px;
          font-weight: 400;
          font-family: PingFang SC;

          .address--lable {
            color: rgba(33, 40, 49, 1);
          }

          .address--cont {
            width: 75%;
            color: rgba(33, 40, 49, 1);
          }
        }
      }
    }

    .tips {
      position: relative;
      width: 263px;
      margin: -62px auto 0;
      font-size: 13px;
      font-weight: 400;
      font-family: PingFang SC;
      text-align: center;
      color: rgba(133, 140, 150, 1);
    }
  }
}
</style>
